import React, { ReactNode } from 'react'
import { Button, ConfirmationModal } from '@components/common'
import './ConfirmBlockModalStyle.css'

type ConfirmBlockModalProps = {
  className?: string
  show: boolean
  onHide: () => void
  mainText: string
  subText: ReactNode
  action: string
  onConfirm: () => void
  backdrop?: boolean | 'static'
  confirmDisabled?: boolean
}

const ConfirmBlockModal: React.FC<ConfirmBlockModalProps> = ({
  className = '',
  show,
  onConfirm,
  onHide,
  mainText,
  subText,
  action,
  backdrop,
  confirmDisabled = false,
}) => {
  const handleConfirm = (): void => {
    if (confirmDisabled) return
    onConfirm()
    onHide()
  }

  const bodyTitle = mainText.endsWith('?') ? mainText : `${mainText}?`

  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      title={mainText}
      className={`confirmation-modal--alert block-confirm-modal ${className}`}
      headerClassName="confirmation-modal__header"
      size="md"
      backdrop={backdrop}
      body={
        <div className="confirmation-modal__body">
          <p className="confirmation-modal__title">{bodyTitle}</p>
          <div className="confirmation-modal__message">{subText}</div>
        </div>
      }
      footer={
        <div className="confirmation-modal__footer">
          <Button className="button-secondary" size="md" onClick={onHide}>
            Cancel
          </Button>
          <Button
            size="md"
            onClick={handleConfirm}
            className="button-destructive-primary"
            disabled={confirmDisabled}
          >
            {action}
          </Button>
        </div>
      }
    />
  )
}

export default ConfirmBlockModal
